import ArticleHistory from "containers/Vendor/Article/ArticleHistory";
import Articles from "containers/Vendor/Article/Articles";
import {Route, Switch, useHistory} from "react-router-dom";

export const ALL_ARTICLES_ROUTE = 'all-shops-articles'
export const BASE_ARTICLE_ROUTE = 'article';
export const ARTICLE_HISTORY_SUFFIX = 'history';


export function AdminArticlesRoutes () {
    const history = useHistory();
    return (
        <Switch>
            <Route exact path={`/${ALL_ARTICLES_ROUTE}`}>
                <Articles />
            </Route>
            <Route path={`/${ALL_ARTICLES_ROUTE}/${BASE_ARTICLE_ROUTE}/:id?/${ARTICLE_HISTORY_SUFFIX}`}>
                <ArticleHistory goBack={() => history.goBack()} />
            </Route>
        </Switch>
    )

}